<template>
  <layout>
    <page-header :header="$t('airports.edit_airport')" />
    <div class="content">
      <b-card>
        <resource-form
          :id="$route.params.id"
          @saved="returnBack"
          @cancelled="returnBack"
        />
      </b-card>
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'airports'

export default {
  name: 'AirportEdit',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
